import { createFileRoute } from "@tanstack/react-router";

import { orderCreateSearchParamsSchema } from "../../../pages/order-create-page/types";

export const Route = createFileRoute("/_layout-main/orders/create")({
  validateSearch: orderCreateSearchParamsSchema,
});
